export const DEFAULT_PLAYBACK_VOLUME = 100
export const PLAYBACK_VOLUME_STORAGE_KEY = 'miosegno.playback.volume'
export const WAKE_LOCK_STORAGE_KEY = 'miosegno.wake-lock.enabled'

export function clampPlaybackVolume(value: number): number {
  if (!Number.isFinite(value)) return DEFAULT_PLAYBACK_VOLUME
  return Math.min(100, Math.max(0, Math.round(value)))
}

export function parseStoredPlaybackVolume(value: string | null): number {
  if (value == null || value.trim() === '') return DEFAULT_PLAYBACK_VOLUME
  return clampPlaybackVolume(Number(value))
}

export function parseStoredBoolean(value: string | null, fallback: boolean): boolean {
  if (value == null) return fallback
  if (value === 'true') return true
  if (value === 'false') return false
  return fallback
}
